let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fxSO8")).then(() => parcelRequire('1HKGQ'));